import { ICustomBinding } from '#/DefaultViewExtensionInterfaces';
import ComponentManager from '@/Management/ComponentManager';
import LabelT from '@/Controls/Label';

export default class BreadCrumbBinding implements ICustomBinding {

    initBinding() {
        ko.bindingHandlers.breadcrumbElements = {
            init: (element: HTMLElement, valueAccessor: () => any) => {
                let Label = ComponentManager.getControl<typeof LabelT>('Label');

                let breadcrumb = $(element);
                let options = valueAccessor();
                let elements = options.elements;

                let onElementsChange = (elements) => {
                    breadcrumb.empty();
                    options.parent.elements = [];

                    for (let i = 0; i < elements.length; i++) {
                        let active = i === elements.length - 1 ? 'active' : '';
                        let label = new Label(elements[i], $('<span class="' + active + '">').appendTo(breadcrumb));
                        let tuple = label.getTuple();

                        ko.applyBindingsToNode(tuple.control[0], {
                            autoLocator: { parent: options.parent.context.locator, name: String(i) }
                        });

                        options.parent.elements.push(label);
                    }

                    $('<div class="clear"></div>').appendTo(breadcrumb);
                }

                let subscription = elements.subscribe(onElementsChange);
                ko.utils.domNodeDisposal.addDisposeCallback(breadcrumb[0], () => {
                    subscription.dispose();
                });
                onElementsChange(elements());
            }
        };
    }
}